import Button from '@srm/ui/button';
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
import './TableFormNavigation.scss';

interface ITableFormNavigationProps {
    currentIndex: number;
    count: number;
    disabled?: boolean;
    onNavigate: (index: number) => void;
}

const TableFormNavigation = ({ currentIndex, count, disabled, onNavigate }: ITableFormNavigationProps) => (
    <div className="table-form-navigation">
        <nav className="table-form-navigation__controls" aria-label="Навигация по строкам" aria-busy={disabled}>
            <Button
                type="button"
                variant="outline-neutral"
                size="sm"
                aria-label="Предыдущая строка"
                startAdornment={<MdChevronLeft size="18" aria-hidden />}
                disabled={disabled || currentIndex <= 0}
                onClick={() => onNavigate(currentIndex - 1)}
            >
                Предыдущая
            </Button>
            <select
                className="table-form-navigation__position"
                aria-label="Перейти к позиции"
                value={currentIndex}
                disabled={disabled}
                onChange={(event) => onNavigate(Number(event.target.value))}
            >
                {Array.from({ length: count }, (_, index) => (
                    <option key={index} value={index}>
                        Позиция {index + 1} из {count}
                    </option>
                ))}
            </select>
            <Button
                type="button"
                size="sm"
                aria-label="Следующая строка"
                endAdornment={<MdChevronRight size="18" aria-hidden />}
                disabled={disabled || currentIndex >= count - 1}
                onClick={() => onNavigate(currentIndex + 1)}
            >
                Следующая
            </Button>
        </nav>
    </div>
);

export default TableFormNavigation;
